import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaNFCeContingenciaRequest } from '../../requests/dfe/lista-nfce-contingencia.request';
import { ListaNFCeContingenciaResponse } from '../../responses/dfe/lista-nfce-contingencia.response';

@Injectable({
  providedIn: 'root',
})
export class NFCeContingenciaService extends CommonService {
  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  private readonly apiUrl = `${environment.urlApiDFe}NFCe`;

  /**
   * Obtém a lista paginada de NFC-es em contingência da empresa.
   * Usa o token JWT para identificar a empresa. O emissor é um filtro opcional.
   */
  public getAll(filter: ListaNFCeContingenciaRequest, paginaAtual: number = 1, tamanhoPagina: number = 20): Observable<ListaNFCeContingenciaResponse> {
    const url = `${this.apiUrl}/listar/contingencia-pendentes`;
    let params = new HttpParams()
      .set('paginaAtual', paginaAtual.toString())
      .set('tamanhoPagina', tamanhoPagina.toString());

    if (filter.idEmissor != null) params = params.set('idEmissor', filter.idEmissor.toString());
    if (filter.idTipoAmbiente != null) params = params.set('idTipoAmbiente', filter.idTipoAmbiente.toString());
    if (filter.idStatusSecundarioDocumento != null) params = params.set('idStatusSecundarioDocumento', filter.idStatusSecundarioDocumento.toString());
    if (filter.serie != null) params = params.set('serie', filter.serie.toString());
    if (filter.pesquisarNumero) params = params.set('pesquisarNumero', filter.pesquisarNumero);
    if (filter.pesquisarCliente) params = params.set('pesquisarCliente', filter.pesquisarCliente);
    if (filter.numeroInicial != null) params = params.set('numeroInicial', filter.numeroInicial.toString());
    if (filter.numeroFinal != null) params = params.set('numeroFinal', filter.numeroFinal.toString());
    if (filter.dataHoraEmissaoInicial != null) params = params.set('dataHoraEmissaoInicial', filter.dataHoraEmissaoInicial.toISOString());
    if (filter.dataHoraEmissaoFinal != null) params = params.set('dataHoraEmissaoFinal', filter.dataHoraEmissaoFinal.toISOString());

    return this.httpClient
      .get<ListaNFCeContingenciaResponse>(url, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }
}
